import { useState } from 'react';
import { getOrgInitials } from '../../lib/getOrgInitials';
import styles from './Avatar.module.css';

/**
 * Avatar Component - Displays organization avatar with fallback to initials
 * 
 * @param {Object} props
 * @param {string} props.src - URL of the avatar image
 * @param {string} props.orgName - Organization name for generating initials
 * @param {('small'|'medium')} props.size - Size variant (small: 32px, medium: 80px)
 * @param {string} props.alt - Alt text for the image
 * @param {string} props.className - Additional CSS classes
 * 
 * Usage:
 * <Avatar src={org.metadata?.avatar_image_url} orgName={org.name} size="medium" />
 */
const Avatar = ({ 
    src, 
    orgName = '', 
    size = 'medium', 
    alt = 'Organization avatar',
    className = ''
}) => {
    const [imageError, setImageError] = useState(false);
    const initials = getOrgInitials(orgName);
    const showImage = src && !imageError;

    const handleImageError = () => {
        setImageError(true);
    };

    return (
        <div className={`${styles.avatar} ${styles[size]} ${className}`}>
            {showImage ? (
                <img 
                    src={src} 
                    alt={alt}
                    className={styles.avatarImage}
                    onError={handleImageError}
                />
            ) : (
                <div className={styles.avatarFallback}>
                    {initials ? initials : <i className="fa-solid fa-user" />}
                </div>
            )}
        </div>
    );
};

export default Avatar;
